/*
* @描述: 订单管理
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-20 16:09:36
*/
<template>
    <div class="page_container">
        <el-tabs v-model="tabActiveName" class="list_page_tabs" @tab-click="handleClickTab">
            <el-tab-pane label="订单列表" name="order">
                <div v-loading="loading" class="el_tab_pane_wrap">
                    <div class="page-filter_wrap">
                        <div class="page-filter_wrap_left">
                            <el-input ref="order_search_input"
                                      v-model="searchForm.keyword"
                                      class="filter-input"
                                      clearable
                                      placeholder="请输入您想搜索的内容"
                                      @blur="handleClickSearch"
                                      @clear="handleClickSearch"
                                      @keyup.enter.native="handleOrderKeyupEnter">
                                <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                            </el-input>
                            <ListAdvancedFiltering :field_form="'order'"
                                                   :field_list="formInfoList"
                                                   v-if="formInfoList.length||systemFilterFields.length"
                                                   :system_fields="systemFilterFields"
                                                   @sendFilterData="getFilterData"/>
                        </div>
                        <div class="page-filter_wrap_right">
                            <el-button v-auth="'order.edit'"
                                       type="primary"
                                       @click="handleClickAddOrder">新建订单
                            </el-button>
                        </div>
                    </div>
                    <div class="page_table_content">
                        <CustomVxeTable v-if="tabActiveName==='order'"
                                        id="orderTableList"
                                        ref="orderTableList"
                                        :class="{ 'custom-table': filterCount && !selectedList.length }"
                                        :customConfig="tableCustomConfig"
                                        :empty-render="{ name: 'NotData' }"
                                        :isShowToolBar="true"
                                        :pagination.sync="pagination"
                                        :reduceHeight="reduceHeight"
                                        :tableData="orderTableList"
                                        @handleCurrentChange="handleCurrentChange"
                                        @handleSizeChange="handleSizeChange"
                                        @custom="handleColumnConfigChange"
                                        @selection-change="selectionChange">
                            <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                            <vxe-column field="order_num" fixed="left" title="订单编号" width="230">
                                <template #default="{ row }">
                                    <div v-if="row.is_release===0" class="order_is_release">订单未发布</div>
                                    <div v-else class="order_num_wrap">
                                        <el-tooltip v-if="row.order_status===0"
                                                    effect="dark"
                                                    content="审批中"
                                                    placement="top">
                                            <span class="handle_icon_wrap">
                                                <i class="iconfont icon-jinhangzhong"></i>
                                            </span>
                                        </el-tooltip>
                                        <el-tooltip v-else-if="row.order_status===2"
                                                    effect="dark"
                                                    content="已拒绝"
                                                    placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap">
                                                <i class="iconfont icon-tingyong"></i>
                                            </span>
                                        </el-tooltip>
                                        <el-tooltip v-else-if="row.order_status===3"
                                                    effect="dark"
                                                    content="已撤销"
                                                    placement="top">
                                            <span class="handle_icon_wrap">
                                                <i class="iconfont icon-chehui"></i>
                                            </span>
                                        </el-tooltip>
                                        <el-tooltip v-else-if="row.order_status===5"
                                                    effect="dark"
                                                    content="已关闭"
                                                    placement="top">
                                            <span class="handle_icon_wrap">
                                                <i class="el-icon-circle-close"></i>
                                            </span>
                                        </el-tooltip>
                                        <div :class="{'is_bad_debt':row.is_bad_debt===1}" class="order_num">
                                            <span @click="handleClickOrderDetail(row)" v-text="row.order_num"></span>
                                            <span v-if="row.is_bad_debt===1">（坏账）</span>
                                        </div>
                                        <el-tooltip content="复制"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap copy_icon"
                                                  @click="handleClickCopyOrderNum(row.order_num)">
                                                <i class="iconfont icon-fuzhi"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column v-for="field in formInfoList"
                                        :key="field.field_key"
                                        :align="field.align?'right':'left'"
                                        :field="field.field_key"
                                        :title="field.field_name"
                                        show-overflow
                                        width="150">
                                <template #default="{ row }">
                                    <div v-if="field.field_type==='contact'">
                                        <div v-if="row[field.field_key].length">
                                            <div v-for="item in row[field.field_key]"
                                                 class="custom_contact_field_wrap">
                                                <PersonnelCard v-if="item.id" :userId="item.id">
                                                    <template slot="container">
                                                        <img :src="item.avatar?item.avatar:defaultImg" alt=""
                                                             class="avatar">
                                                        <span class="name" v-text="item.name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='department'">
                                        <div v-if="row[field.field_key].length">
                                            <div v-for="item in row[field.field_key]">
                                                <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                    <span v-text="item.department_name"></span>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='radio'">
                                    <span v-if="row[field.field_key]"
                                          :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                          v-text="row[field.field_key]"></span>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='checkbox'">
                                        <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                              v-text="item">
                                        </span>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='checkbox_user_tag'">
                                        <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              class="is_tag_interaction"
                                              v-text="item.name">
                                        </span>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='image'">
                                        <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                            <el-image
                                                    :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                    :src="row[field.field_key][0].file_path"
                                                    fit="cover">
                                            </el-image>
                                            <el-popover :visible-arrow="false"
                                                        placement="bottom-start"
                                                        popper-class="table_custom_image_popover"
                                                        title=""
                                                        trigger="hover"
                                                        width="254">
                                                <div slot="reference">
                                                <span v-if="row[field.field_key].length>1"
                                                      class="image_count"
                                                      v-text="`+${row[field.field_key].length-1}`"></span>
                                                </div>
                                                <ul class="image_list">
                                                    <li v-for="(img,img_index) in row[field.field_key]"
                                                        :key="img_index"
                                                        class="image_item">
                                                        <el-image
                                                                :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                                :src="img.file_path"
                                                                fit="cover">
                                                        </el-image>
                                                    </li>
                                                </ul>
                                            </el-popover>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='file'">
                                        <div v-if="row[field.field_key].length" class="table_custom_file_wrap">
                                            <div class="first_file_wrap">
                                                <div class="file_name_wrap"
                                                     v-text="row[field.field_key][0].file_name"></div>
                                                <div class="file_right_wrap">
                                                    <el-tooltip content="预览"
                                                                effect="dark"
                                                                placement="top">
                                                        <span class="handle_icon_wrap"
                                                              @click="handleClickPreview(row[field.field_key][0])">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                                    </el-tooltip>
                                                    <span class="line"></span>
                                                    <el-tooltip content="下载"
                                                                effect="dark"
                                                                placement="top">
                                                        <span class="handle_icon_wrap"
                                                              @click="handleClickDownloadFile(row[field.field_key][0])">
                                                            <i class="iconfont icon-daochu"></i>
                                                        </span>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='invoice'">
                                        <div v-if="row[field.field_key].length"></div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='relate_approve_form'"></div>
                                    <div v-else-if="field.field_type==='id_card'">
                                        <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                            <span v-text="row[field.field_key].value"></span>
                                            <el-popover placement="bottom"
                                                        popper-class="id_card_detail_popper"
                                                        trigger="click"
                                                        width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                                <el-form size="small">
                                                    <el-form-item v-if="row[field.field_key].name" label="姓名"
                                                                  prop="name">
                                                        <span v-text="row[field.field_key].name"></span>
                                                    </el-form-item>
                                                    <el-form-item v-if="row[field.field_key].birthday" label="出生日期"
                                                                  prop="birthday">
                                                        <span v-text="row[field.field_key].birthday"></span>
                                                    </el-form-item>
                                                    <el-form-item v-if="row[field.field_key].address" label="家庭住址"
                                                                  prop="name">
                                                        <span v-text="row[field.field_key].address"></span>
                                                    </el-form-item>
                                                    <el-form-item label="身份证号" prop="value">
                                                        <span v-text="row[field.field_key].value"></span>
                                                    </el-form-item>
                                                </el-form>
                                                <img alt=""
                                                     class="ic_card_icon"
                                                     src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png">
                                            </el-popover>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='paying_teller'">
                                        <div v-if="row[field.field_key]&&row[field.field_key].text"
                                             class="custom_paying_teller_field_wrap">
                                            <span v-text="row[field.field_key].text"></span>
                                            <el-popover placement="bottom"
                                                        popper-class="paying_teller_detail_popper"
                                                        trigger="click"
                                                        width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                                <el-form class="custom_detail_form" label-position="top"
                                                         size="small">
                                                    <el-form-item label="账户类型" prop="account_type">
                                                        <span v-text="row[field.field_key].account_type===1?'个人账户':'对公账户'"></span>
                                                    </el-form-item>
                                                    <el-form-item label="户名" prop="account_name">
                                                        <span v-text="row[field.field_key].account_name"></span>
                                                    </el-form-item>
                                                    <el-form-item label="账号" prop="card_number">
                                                        <span v-text="row[field.field_key].card_number"></span>
                                                    </el-form-item>
                                                    <el-form-item label="所属银行" prop="bank_name">
                                                        <span v-text="row[field.field_key].bank_name"></span>
                                                    </el-form-item>
                                                    <el-form-item v-if="field.extend.bank_branch_is_show"
                                                                  label="银行支行"
                                                                  prop="bank_branch">
                                                        <span v-text="row[field.field_key].bank_branch"></span>
                                                    </el-form-item>
                                                </el-form>
                                            </el-popover>
                                        </div>
                                        <span v-else>--</span>
                                    </div>
                                    <div v-else-if="field.field_type==='table'">
                                    </div>
                                    <div v-else-if="field.field_type==='radio_customer'">
                                        <span class="link-label"
                                              @click="handleClickRelateCompanyDetail(row)"
                                              v-text="row.customer_id.text"></span>
                                    </div>
                                    <div v-else-if="field.field_type==='radio_project'">
                                            <span class="link-label"
                                                  @click="handleClickRelateProjectDetail(row)"
                                                  v-text="row.project_id.text"></span>
                                    </div>
                                    <div v-else-if="field.field_type==='customer_contact'">
                                        <span v-for="item in row.contact_id" v-text="item.name"></span>
                                    </div>
                                    <div v-else-if="field.field_type==='checkbox_approval'">
                                        <el-popover v-if="row[field.field_key]&&row[field.field_key].text.length"
                                                    placement="top"
                                                    trigger="hover"
                                                    width="460">
                                            <el-link slot="reference"
                                                     :underline="false"
                                                     type="primary">
                                                {{field.field_name }}（+{{ row[field.field_key].text.length }}）
                                            </el-link>
                                            <ul class="related_approval_list table_related_approval_list">
                                                <li v-for="(item,index) in row[field.field_key].text"
                                                    class="related_approval_item">
                                                    <div class="flex_js_wrap">
                                                        <div class="related_approval_title flex_wrap">
                                                            <h4 v-text="item.approval_set_name"></h4>
                                                            <div :class="'relate_approve_status_' + item.status"
                                                                 class="relate_approve_status"
                                                                 v-text="item.status === 0 ? '审批中' : item.status === 1 ? '已通过' : item.status === 2 ? '已拒绝' : '已撤回'"></div>
                                                        </div>
                                                        <div class="flex_wrap">
                                                            <el-link :underline="false"
                                                                     type="primary"
                                                                     @click="handleClickRelatedApprovalDetail(item)">
                                                                详情
                                                            </el-link>
                                                        </div>
                                                    </div>
                                                    <div class="flex_wrap approve_created_at">
                                                        <span v-text="item.user.name"></span>
                                                        <span>提交于</span>
                                                        <span v-text="item.created_at"></span>
                                                    </div>
                                                    <div v-if="item.overview_fields&&item.overview_fields.length"
                                                         class="overview_fields_wrap">
                                                        <div v-if="item.is_pack_up">
                                                            <OverviewFields
                                                                    :overviewFields="item.overview_fields"/>
                                                        </div>
                                                        <div class="ta_c">
                                                            <el-link :underline="false"
                                                                     type="primary"
                                                                     @click="handleApproveOverViewField(item)">
                                                                {{
                                                                    item.is_pack_up ? '收起' : '展开'
                                                                }}
                                                                <i :class="item.is_pack_up?'icon-shangjiantou':'icon-xiajiantou'"
                                                                   class="iconfont"></i>
                                                            </el-link>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </el-popover>
                                        <div v-else>--</div>
                                    </div>
                                    <div v-else-if="field.field_type==='system'">
                                    </div>
                                    <span v-else
                                          v-text="row[field.field_key]?row[field.field_key]:'--'"></span>
                                </template>
                            </vxe-column>
                            <vxe-column align="right" field="total_repay_price" min-width="100"
                                        title="已回款金额"></vxe-column>
                            <vxe-column align="right" field="no_repay_price" min-width="100"
                                        title="待回款金额"></vxe-column>
                            <vxe-column field="repay_price_ratio" title="实际回款金额（回款比例）"
                                        width="200"></vxe-column>
                            <vxe-column align="right" field="invoice_price" min-width="100"
                                        title="总开票金额"></vxe-column>
                            <vxe-column align="right" field="no_invoice_price" min-width="100"
                                        title="可开票金额"></vxe-column>
                            <vxe-column align="right" field="purchase_cost_price" min-width="100"
                                        title="代采成本"></vxe-column>
                            <vxe-column :visible="false" field="is_expire_goods" title="是否有到期设备"
                                        width="130"></vxe-column>
                            <vxe-column field="deliver_status" min-width="80" title="出库状态"></vxe-column>
                            <vxe-column :visible="false" field="is_return_goods" min-width="150"
                                        title="是否有未归还设备"></vxe-column>
                            <vxe-column field="created_at" min-width="160" title="创建时间"></vxe-column>
                            <vxe-column field="operate" fixed="right" width="90">
                                <template #header>
                                    <span>操作</span>
                                    <el-tooltip class="item"
                                                content="表头设置"
                                                effect="dark"
                                                placement="bottom-start">
                                        <i class="iconfont icon-biaotoushezhi table-header-icon"
                                           @click="handleClickCustom"></i>
                                    </el-tooltip>
                                </template>
                                <template #default="{ row }">
                                    <div class="flex_wrap">
                                        <el-tooltip v-if="row.order_status===0&&row['order.edit']"
                                                    effect="dark"
                                                    content="撤销"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickRevokeOrder(row)">
                                                <i class="iconfont icon-chexiao"></i>
                                            </span>
                                        </el-tooltip>
                                        <el-tooltip v-else-if="row.order_status===1&&row['order.edit']"
                                                    effect="dark"
                                                    content="售后"
                                                    placement="top">
                                            <span class="handle_icon_wrap"
                                                  @click="handleClickAfterSales(row)">
                                                <i class="iconfont icon-huanhuo1"></i>
                                            </span>
                                        </el-tooltip>
                                        <el-tooltip v-else-if="row.order_status===4&&row['order.edit']"
                                                    effect="dark"
                                                    content="编辑"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickEditOrder(row.order_id)">
                                                <i class="iconfont icon-bianji"></i>
                                            </span>
                                        </el-tooltip>
                                        <el-tooltip
                                                v-else-if="row.order_status===2||row.order_status===3||row.order_status===5&&row['order.edit']"
                                                content="重新发起"
                                                effect="dark"
                                                placement="top">
                                            <span class="handle_icon_wrap"
                                                  @click="handleClickSubmitAgain(row.order_id)">
                                                 <i class="iconfont icon-refresh"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-dropdown placement="bottom-end" trigger="click">
                                            <el-tooltip content="更多" effect="dark" placement="top">
                                                <span class="handle_icon_wrap">
                                                    <i class="iconfont el-icon-more"></i>
                                                </span>
                                            </el-tooltip>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item
                                                        v-if="row.order_status===2||row.order_status===3||row.order_status===4||row.order_status===5"
                                                        @click.native="handleClickDelOrder(row.order_id)">删除
                                                </el-dropdown-item>
                                                <el-dropdown-item v-if="row.order_status===0||row.order_status===1"
                                                                  @click.native="handleClickCopyOrder(row.order_id)">
                                                    复制订单
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                        v-if="row.order_status===1&&Number(row.purchase_price)!==0&&row['order.edit']"
                                                        @click.native="handleClickAddPurchase(row.order_id)">
                                                    新增代采
                                                </el-dropdown-item>
                                                <el-dropdown-item v-if="row.order_status===1&&row['order.edit']"
                                                                  @click.native="handleClickAddMember(row.order_id)">
                                                    添加成员
                                                </el-dropdown-item>
                                                <el-dropdown-item v-if="row.order_status===1&&hasClosePermission"
                                                                  @click.native="handleClickCloseOrder(row.order_id)">
                                                    关闭订单
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </template>
                            </vxe-column>
                        </CustomVxeTable>
                    </div>
                    <OrderAdd v-if="addOrderDialogVisible"
                              :dialogVisible.sync="addOrderDialogVisible"
                              @refresh-list="getOrderTableList"/>
                    <OrderSubmitAgain v-if="submitAgainOrderDialogVisible"
                                      :dialogVisible.sync="submitAgainOrderDialogVisible"
                                      :order_id="order_id"
                                      @refresh-list="getOrderTableList"/>
                    <OrderEdit v-if="editOrderDialogVisible"
                               :dialogVisible.sync="editOrderDialogVisible"
                               :order_id="order_id"
                               @refresh-list="getOrderTableList"/>
                    <orderAfterSale v-if="orderAfterSaleDialog"
                                    :dialogVisible.sync="orderAfterSaleDialog"
                                    :order_id="order_id"
                                    :orderInfo="orderAfterSaleInfo"
                                    @order_edit="handleClickEditOrder"
                                    @refresh="getOrderTableList"/>
                    <OrderAddMember v-if="teamMembersAddVisible"
                                    :dialogVisible.sync="teamMembersAddVisible"
                                    :order_ids="[order_id]"/>
                    <OrderPurchaseAdd v-if="orderPurchaseAddVisible"
                                      :order_id="order_id"
                                      :dialogVisible.sync="orderPurchaseAddVisible"
                                      @refresh="getOrderTableList"/>
                    <el-image ref="preview_img"
                              :preview-src-list="previewImgList"
                              :src="previewImgSrc"
                              style="display:none">
                    </el-image>
                </div>
            </el-tab-pane>
            <el-tab-pane label="回款汇总" name="payment">
                <div v-loading="loading" class="el_tab_pane_wrap">
                    <div class="page-filter_wrap">
                        <div class="page-filter_wrap_left">
                            <el-input ref="payment_search_input"
                                      v-model="paymentFilter.keyword"
                                      class="filter-input"
                                      clearable
                                      placeholder="请输入您想搜索的内容"
                                      @blur="handleClickPaymentSearch"
                                      @clear="handleClickPaymentSearch"
                                      @keyup.enter.native="handlePaymentKeyupEnter">
                                <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickPaymentSearch"></i>
                            </el-input>
                            <el-popover ref="paymentFilterPopover"
                                        placement="bottom-start"
                                        popper-class="filter_popper"
                                        trigger="click">
                                 <span slot="reference">
                                    <div class="filter_popper_btn">
                                        <el-button class="custom_btn" size="small"><i
                                                class="iconfont icon-shaixuan"></i></el-button>
                                    </div>
                                </span>
                                <div class="advanced_filter_wrap">
                                    <div class="filter_title_wrap">
                                        <span>筛选</span>
                                        <div>
                                            <span>符合以下：</span>
                                            <el-button @click="handleClickClearPaymentCondition">清空筛选条件
                                            </el-button>
                                        </div>
                                    </div>
                                    <div class="filter_content_wrap">
                                        <ul class="advanced_filter_list">
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-select v-model="paymentFilter.status_filter_name"
                                                               disabled
                                                               size="small">

                                                    </el-select>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-select v-model="paymentFilter.operator" disabled
                                                               size="small"></el-select>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-select v-model="paymentFilter.status"
                                                               collapse-tags
                                                               multiple
                                                               placeholder="请选择状态"
                                                               size="small"
                                                               @change="getOrderPaymentList">
                                                        <el-option :value="1" label="待确认"></el-option>
                                                        <el-option :value="2" label="已确认"></el-option>
                                                        <el-option :value="3" label="已驳回"></el-option>
                                                        <el-option :value="4" label="已撤销"></el-option>
                                                        <el-option :value="5" label="已作废"></el-option>
                                                    </el-select>
                                                </div>
                                            </li>
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-select v-model="paymentFilter.payment_date_filter_name"
                                                               disabled
                                                               size="small">

                                                    </el-select>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-select v-model="paymentFilter.operator" disabled
                                                               size="small"></el-select>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-date-picker v-model="paymentFilter.payment_date"
                                                                    :editable="false"
                                                                    end-placeholder="结束日期"
                                                                    format="yyyy/MM/dd"
                                                                    range-separator="～"
                                                                    size="small"
                                                                    start-placeholder="开始日期"
                                                                    type="daterange"
                                                                    value-format="yyyy-MM-dd"
                                                                    @change="getOrderPaymentList">
                                                    </el-date-picker>
                                                </div>
                                            </li>
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-select v-model="paymentFilter.payment_method_filter_name"
                                                               disabled
                                                               size="small">

                                                    </el-select>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-select v-model="paymentFilter.operator" disabled
                                                               size="small"></el-select>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-select v-model="paymentFilter.payment_method"
                                                               collapse-tags
                                                               multiple
                                                               placeholder="请选择回款方式"
                                                               size="small"
                                                               @change="getOrderPaymentList">
                                                        <el-option :value="1" label="电汇"></el-option>
                                                        <el-option :value="2" label="微信"></el-option>
                                                        <el-option :value="3" label="支付宝"></el-option>
                                                        <el-option :value="4" label="现金"></el-option>
                                                        <el-option :value="5" label="银行承兑"></el-option>
                                                        <el-option :value="6" label="商业承兑"></el-option>
                                                        <el-option :value="7" label="支票"></el-option>
                                                    </el-select>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </div>
                        <div class="page-filter_wrap_right">
                            <el-button type="primary" @click="handleClickAddRepayment">新建回款
                            </el-button>
                        </div>
                    </div>
                    <div class="page_table_content">
                        <CustomVxeTable
                                v-if="tabActiveName==='payment'"
                                ref="orderPaymentList"
                                :customConfig="tableCustomConfig"
                                :empty-render="{ name: 'NotData' }"
                                :isShowToolBar="true"
                                :pagination.sync="paymentPagination"
                                :reduceHeight="reduceHeight"
                                :tableData="orderPaymentList"
                                @handleCurrentChange="handleCurrentChange"
                                @handleSizeChange="handleSizeChange"
                                @selection-change="selectionChange">
                            <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                            <vxe-column fixed="left" title="回款编号">
                                <template #default="{ row }">
                                    <div class="link-label"
                                         @click="handleClickPaymentDetail(row)"
                                         v-text="row.receivable_no"></div>
                                </template>
                            </vxe-column>
                            <vxe-column title="关联订单">
                                <template #default="{ row }">
                                    <div class="link-label"
                                         @click="handleClickOrderDetail(row)"
                                         v-text="row.order_no"></div>
                                </template>
                            </vxe-column>
                            <vxe-column field="payment_company_name" title="回款客户"></vxe-column>
                            <vxe-column title="申请人">
                                <template #default="{ row }">
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard v-if="row.uid_info"
                                                       :userId="row.uid_info.id">
                                            <template slot="container">
                                                <img :src="row.uid_info.avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.uid_info.name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column field="payment_date" title="回款日期"></vxe-column>
                            <vxe-column field="payment_method_name" title="回款方式"></vxe-column>
                            <vxe-column align="right" field="payment_amount" title="回款金额">
                                <template #default="{ row }">
                                    <div v-text="'¥'+row.payment_amount"></div>
                                </template>
                            </vxe-column>
                            <vxe-column title="状态" width="130">
                                <template #default="{ row }">
                                    <span :class="'payment_status_name_'+row.status" class="status_name"
                                          v-text="row.status_name"></span>
                                    <el-tooltip v-if="row.status===3" :content="row.reject_reason" effect="dark"
                                                placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="row.status===5" :content="row.invalid_reason" effect="dark"
                                                placement="top">
                                             <span class="handle_icon_wrap">
                                                <i class="iconfont icon-jinggao"></i>
                                            </span>
                                    </el-tooltip>
                                </template>
                            </vxe-column>
                            <vxe-column field="operate" fixed="right" width="90">
                                <template #header>
                                    <span>操作</span>
                                    <!--                                    <el-tooltip class="item"
                                                                                    content="表头设置"
                                                                                    effect="dark"
                                                                                    placement="bottom-start">
                                                                            <i class="iconfont icon-biaotoushezhi table-header-icon"
                                                                               @click="handleClickCustom"></i>
                                                                        </el-tooltip>-->
                                </template>
                                <template #default="{ row }">
                                    <el-link v-if="row.status===1&&row.uid==userInfo.user.id"
                                             :underline="false"
                                             type="danger"
                                             @click="handleClickPaymentRevoke(row)">撤销
                                    </el-link>
                                    <el-link v-else-if="row.status===3||row.status===4||row.status===5"
                                             :underline="false"
                                             type="primary"
                                             @click="handleClickPaymentAgain(row)">重新发起
                                    </el-link>
                                </template>
                            </vxe-column>
                        </CustomVxeTable>
                    </div>
                    <RepaymentDialog v-if="repaymentDialogVisible"
                                     :receivable_no.sync="receivable_no"
                                     :order_id="relate_order_id"
                                     :dialogVisible.sync="repaymentDialogVisible"
                                     @refresh="getOrderPaymentList"/>
                    <RepaymentDetail v-if="repaymentDetailDialogVisible"
                                     :dialogVisible.sync="repaymentDetailDialogVisible"
                                     :receivable_no.sync="receivable_no"/>
                </div>
            </el-tab-pane>
            <el-tab-pane label="开票汇总" name="invoice">
                <div v-loading="loading" class="el_tab_pane_wrap">
                    <div class="page-filter_wrap">
                        <div class="page-filter_wrap_left">
                            <el-input ref="invoice_search_input"
                                      v-model="invoiceFilter.keyword"
                                      class="filter-input"
                                      clearable
                                      placeholder="请输入您想搜索的内容"
                                      @blur="handleClickInvoiceSearch"
                                      @clear="handleClickInvoiceSearch"
                                      @keyup.enter.native="handleInvoiceKeyupEnter">
                                <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickInvoiceSearch"></i>
                            </el-input>
                            <el-popover ref="invoiceFilterPopover"
                                        placement="bottom-start"
                                        popper-class="filter_popper"
                                        trigger="click">
                                 <span slot="reference">
                                    <div class="filter_popper_btn">
                                        <el-button class="custom_btn" size="small"><i
                                                class="iconfont icon-shaixuan"></i></el-button>
                                    </div>
                                </span>
                                <div class="advanced_filter_wrap">
                                    <div class="filter_title_wrap">
                                        <span>筛选</span>
                                        <div>
                                            <span>符合以下：</span>
                                            <el-button @click="handleClickClearInvoiceCondition">清空筛选条件
                                            </el-button>
                                        </div>
                                    </div>
                                    <div class="filter_content_wrap">
                                        <ul class="advanced_filter_list">
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-select v-model="invoiceFilter.status_filter_name"
                                                               disabled
                                                               size="small">
                                                    </el-select>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-select v-model="invoiceFilter.operator" disabled
                                                               size="small"></el-select>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-select v-model="invoiceFilter.status"
                                                               collapse-tags
                                                               multiple
                                                               placeholder="请选择状态"
                                                               size="small"
                                                               @change="getOrderInvoiceList">
                                                        <el-option :value="1" label="待开票"></el-option>
                                                        <el-option :value="2" label="已开票"></el-option>
                                                        <el-option :value="3" label="已驳回"></el-option>
                                                        <el-option :value="4" label="已作废"></el-option>
                                                        <el-option :value="5" label="已撤销"></el-option>
                                                    </el-select>
                                                </div>
                                            </li>
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-select v-model="invoiceFilter.apply_time_field_name"
                                                               disabled
                                                               size="small">
                                                    </el-select>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-select v-model="invoiceFilter.operator" disabled
                                                               size="small"></el-select>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-date-picker v-model="invoiceFilter.apply_time"
                                                                    :editable="false"
                                                                    end-placeholder="结束日期"
                                                                    format="yyyy/MM/dd"
                                                                    range-separator="～"
                                                                    size="small"
                                                                    start-placeholder="开始日期"
                                                                    type="daterange"
                                                                    value-format="yyyy-MM-dd"
                                                                    @change="getOrderInvoiceList">
                                                    </el-date-picker>
                                                </div>
                                            </li>
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-select v-model="invoiceFilter.invoice_type_filter_name"
                                                               disabled
                                                               size="small">
                                                    </el-select>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-select v-model="invoiceFilter.operator" disabled
                                                               size="small"></el-select>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-select v-model="invoiceFilter.invoice_type"
                                                               collapse-tags
                                                               multiple
                                                               placeholder="请选择发票类型"
                                                               size="small"
                                                               @change="getOrderInvoiceList">
                                                        <el-option :value="1" label="电子专票"></el-option>
                                                        <el-option :value="2" label="电子普票"></el-option>
                                                        <el-option :value="3" label="纸质专票"></el-option>
                                                        <el-option :value="4" label="纸质普票"></el-option>
                                                    </el-select>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </div>
                        <div class="page-filter_wrap_right">
                            <el-button type="primary" @click="handleClickAddInvoice">新建开票
                            </el-button>
                        </div>
                    </div>
                    <div class="page_table_content">
                        <CustomVxeTable
                                v-if="tabActiveName==='invoice'"
                                ref="orderInvoiceList"
                                :customConfig="tableCustomConfig"
                                :empty-render="{ name: 'NotData' }"
                                :isShowToolBar="true"
                                :pagination.sync="invoicePagination"
                                :reduceHeight="reduceHeight"
                                :tableData="orderInvoiceList"
                                @handleCurrentChange="handleCurrentChange"
                                @handleSizeChange="handleSizeChange"
                                @selection-change="selectionChange">
                            <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                            <vxe-column fixed="left" title="开票编号">
                                <template #default="{ row }">
                                    <div class="link-label"
                                         @click="handleClickInvoiceDetail(row)" v-text="row.invoice_no"></div>
                                </template>
                            </vxe-column>
                            <vxe-column title="关联订单">
                                <template #default="{ row }">
                                    <div class="link-label"
                                         @click="handleClickOrderDetail(row)"
                                         v-text="row.relate_id"></div>
                                </template>
                            </vxe-column>
                            <vxe-column field="invoice_company_name" title="开票公司"></vxe-column>
                            <vxe-column title="申请人">
                                <template #default="{ row }">
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard v-if="row.apply_user_info"
                                                       :userId="row.apply_user_info.id">
                                            <template slot="container">
                                                <img :src="row.apply_user_info.avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.apply_user_info.name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column field="invoice_type_name" title="发票类型"></vxe-column>
                            <vxe-column align="right" field="invoice_amount" title="本次开票金额">
                                <template #default="{ row }">
                                    <div v-text="'¥'+row.invoice_amount"></div>
                                </template>
                            </vxe-column>
                            <vxe-column field="apply_time" title="开票申请时间"></vxe-column>
                            <vxe-column field="invoice_number" title="发票号码"></vxe-column>
                            <vxe-column title="状态">
                                <template #default="{ row }">
                                    <span :class="'invoice_status_name_'+row.status"
                                          class="status_name"
                                          v-text="row.status_name"></span>
                                    <el-tooltip v-if="row.status===3" :content="row.reject_reason"
                                                effect="dark"
                                                placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="row.status===4" :content="row.invalid_reason"
                                                effect="dark"
                                                placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                    </el-tooltip>
                                </template>
                            </vxe-column>
                            <vxe-column field="operate" fixed="right" width="90">
                                <template #header>
                                    <span>操作</span>
                                    <!--                                    <el-tooltip class="item"
                                                                                    content="表头设置"
                                                                                    effect="dark"
                                                                                    placement="bottom-start">
                                                                            <i class="iconfont icon-biaotoushezhi table-header-icon"
                                                                               @click="handleClickCustom"></i>
                                                                        </el-tooltip>-->
                                </template>
                                <template #default="{ row }">
                                    <el-link v-if="row.status===1"
                                             :underline="false"
                                             type="danger"
                                             @click="handleClickInvoiceRevoke(row)">撤销
                                    </el-link>
                                    <el-link v-else-if="row.status===3||row.status===4||row.status===5"
                                             :underline="false"
                                             type="primary"
                                             @click="handleClickInvoiceAgain(row)">重新发起
                                    </el-link>
                                </template>
                            </vxe-column>
                        </CustomVxeTable>
                    </div>
                    <InvoiceDialog v-if="invoiceDialogVisible"
                                   :invoice_no.sync="invoice_no"
                                   :order_id="relate_order_id"
                                   :dialogVisible.sync="invoiceDialogVisible"
                                   @refresh="getOrderInvoiceList"/>
                    <InvoiceDetailsDialog v-if="invoiceDetailsDialogVisible"
                                          :dialogVisible.sync="invoiceDetailsDialogVisible"
                                          :invoice_no.sync="invoice_no"/>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import {pagination} from "@/mixins";
import {
    cancelApproval,
    getFormFields,
    orderClose,
    orderDel,
    orderHasAfterSale,
    orderInvoiceRecordCancel,
    orderInvoiceSummary,
    orderList,
    orderRepaymentList,
    orderRepaymentRecordCancel
} from "@/api";
import {mapState, mapGetters} from "vuex";
import {getOSSData} from "@/utils/uploadOss";
import {tableDataFieldShow} from "@/utils";
import {EventBus} from '@/utils/eventBus';
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import OrderAdd from "./component/order_add";
import OrderSubmitAgain from "./component/order_submit_again";
import OrderEdit from "./component/order_edit";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import purchaseDetail from "./component/purchase_detail";
import orderAfterSale from "./component/order_afte_sale";
import OrderAddMember from "@/views/pc/Order/component/add_member";
import InvoiceDialog from "@/views/pc/Order/component/invoice_dialog";
import InvoiceDetailsDialog from "@/views/pc/Order/component/invoice_details";
import RepaymentDialog from "@/views/pc/Order/component/repayment_dialog";
import RepaymentDetail from "@/views/pc/Order/component/repayment_details";
import OrderPurchaseAdd from "./component/order_purchase_add";
import OverviewFields from "@/components/pComponents/overviewFields.vue";

export default {
    name: "Order",
    data() {
        return {
            loading: false,
            tabActiveName: 'order',
            searchForm: {
                keyword: "",
            },
            formInfoList: [],
            systemFilterFields: [
                {
                    field_type: "radio",
                    field_key: 'is_deliver',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '产品租售方式',
                    options: [
                        {
                            label: "包含销售",
                            value: 1,
                        },
                        {
                            label: "包含租借",
                            value: 2,
                        }
                    ],
                    system_type: 'logic',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'is_expire_goods',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '是否有到期设备',
                    options: [
                        {
                            label: "否",
                            value: 0,
                        },
                        {
                            label: "是",
                            value: 1,
                        }
                    ],
                    system_type: 'logic',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'order_status',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '订单状态 ',
                    options: [
                        {
                            label: "审批中",
                            value: 0,
                        },
                        {
                            label: "已通过",
                            value: 1,
                        },
                        {
                            label: "已拒绝",
                            value: 2,
                        },
                        {
                            label: "已撤销",
                            value: 3,
                        },
                        {
                            label: "未发布",
                            value: 4,
                        },
                        {
                            label: "已关闭",
                            value: 5,
                        },
                    ],
                    system_type: 'logic',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'orders.is_deliver',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '是否需要发货',
                    options: [
                        {
                            label: "否",
                            value: 0,
                        },
                        {
                            label: "是",
                            value: 1,
                        }
                    ],
                    system_type: 'system',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'orders.is_bad_debt',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '是否有坏账',
                    options: [
                        {
                            "label": "否",
                            "value": 0,
                        },
                        {
                            "label": "是",
                            "value": 1,
                        }
                    ],
                    system_type: 'system',
                    is_multiple: false,
                },
                {
                    field_type: "money",
                    field_key: 'orders.contract_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '订单总金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.total_repay_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '总回款金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.no_repay_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '待回款金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.repay_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '实际回款金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.invoice_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '总开票金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.no_invoice_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '可开票金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.purchase_cost_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '代采成本',
                    system_type: 'system',
                },
                {
                    field_type: "date",
                    field_key: 'orders.created_at',
                    date_type: 'date',
                    condition_type: 'date_range',
                    is_system: '1',
                    field_name: '创建时间',
                    system_type: 'system',
                },
                {
                    field_type: "radio",
                    field_key: 'orders.deliver_status',
                    is_system: '1',
                    condition_type: 'options',
                    field_name: '发货状态',
                    options: [
                        {
                            "label": "未发货",
                            "value": 1,
                            "default": false,
                            "error": ""
                        },
                        {
                            "label": "全部发货",
                            "value": 2,
                            "default": false,
                            "error": ""
                        },
                        {
                            "label": "部分发货",
                            "value": 3,
                            "default": false,
                            "error": ""
                        },
                    ],
                    system_type: 'system',
                    is_multiple: true,
                },
                {
                    field_type: "radio",
                    field_key: 'orders.is_return_goods',
                    is_system: '1',
                    condition_type: 'options',
                    field_name: '是否有未归还设备',
                    options: [
                        {
                            "label": "否",
                            "value": 0,
                        },
                        {
                            "label": "是",
                            "value": 1,
                        }
                    ],
                    system_type: 'system',
                    is_multiple: true,
                }
            ],
            selectedList: [],
            tableCustomConfig: {
                allowSort: true,
                allowFixed: false,
                allowResizable: true,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "order_num";
                },
            },
            filterCount: 0,
            orderTableList: [],
            addOrderDialogVisible: false,
            editOrderDialogVisible: false,
            submitAgainOrderDialogVisible: false,
            custom_filter: {},
            defaultImg: require('@/assets/images/default.jpg'),
            order_id: 0,
            orderAfterSaleDialog: false,
            orderAfterSaleInfo: {},//订单售后需要的参数
            paymentFilter: {
                keyword: '',
                status: [],
                status_filter_name: '状态',
                payment_date: [],
                payment_date_filter_name: '回款日期',
                payment_method: [],
                payment_method_filter_name: '回款方式',
                operator: '满足'
            },
            invoiceFilter: {
                keyword: '',
                status: [],
                status_filter_name: '状态',
                apply_time: [],
                apply_time_field_name: '开票申请时间',
                invoice_type: [],
                invoice_type_filter_name: '发票类型',
                operator: '满足'
            },
            orderPaymentList: [],
            orderInvoiceList: [],
            repaymentDialogVisible: false,
            invoiceDialogVisible: false,
            invoiceDetailsDialogVisible: false,
            invoice_no: '',
            receivable_no: '',
            repaymentDetailDialogVisible: false,
            teamMembersAddVisible: false,
            orderPurchaseAddVisible: false,
            subimitOrderDialogVisible: false,
            relate_order_id: '',
            previewImgList: [],
            previewImgSrc: '',
            paymentPagination: {
                pageNum: 1,
                pageSizes: [15, 30, 50, 100],
                pageSize: 15,
                total: 0,
                layout: 'total, prev, pager, next, sizes, jumper'
            },
            invoicePagination: {
                pageNum: 1,
                pageSizes: [15, 30, 50, 100],
                pageSize: 15,
                total: 0,
                layout: 'total, prev, pager, next, sizes, jumper'
            },
            order_select_field: []
        }
    },
    components: {
        OverviewFields,
        ListAdvancedFiltering,
        CustomVxeTable,
        OrderAdd,
        OrderSubmitAgain,
        OrderEdit,
        PersonnelCard,
        orderAfterSale,
        purchaseDetail,
        InvoiceDialog,
        InvoiceDetailsDialog,
        RepaymentDialog,
        RepaymentDetail,
        OrderAddMember,
        OrderPurchaseAdd
    },
    mixins: [pagination],
    created() {
        this._getFromFields()
        EventBus.$on('orderUpdated', this.getOrderTableList);
    },
    computed: {
        reduceHeight() {
            return this.filterCount ? 200 : 210
        },
        ...mapState(["userInfo"]),
        ...mapGetters(['hasPermission']),
        hasClosePermission() {
            return this.hasPermission('order.close', 'customer', 'Order');
        },
    },
    mounted() {

    },
    methods: {
        handleClickTab(tab) {
            if (this.tabActiveName === 'payment') {
                this.getOrderPaymentList()
            } else if (this.tabActiveName === 'invoice') {
                this.getOrderInvoiceList()
            }
        },

        //获取自定义字段列表
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'orders',
                filter_field_type: ''
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = []
                    res.data.forEach(item => {
                        if (item._child && item._child.length) {
                            item._child.forEach(item => {
                                if (item.field_key !== 'order_goods') {
                                    this.formInfoList.push(item)
                                }
                            })
                        }
                    })
                    this.getOrderTableList()
                } else {

                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        getOrderTableList() {
            this.loading = true;
            orderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter,
                select_field: this.order_select_field.length ? this.order_select_field : undefined
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.orderTableList = data
                    this.pagination.total = total
                    tableDataFieldShow(this.formInfoList, this.orderTableList)
                }
                this.loading = false;
            })
        },

        handleClickSearch() {
            this.pagination.pageNum = 1
            this.getOrderTableList()
        },

        handleOrderKeyupEnter() {
            this.$refs.order_search_input.blur()
        },

        handlePaymentKeyupEnter() {
            this.$refs.invoice_search_input.blur()
        },

        handleInvoiceKeyupEnter() {
            this.$refs.invoice_search_input.blur()
        },

        getFilterData(data) {
            this.custom_filter = data;
            this.getOrderTableList()
        },

        // 表头配置
        handleClickCustom() {
            if (this.tabActiveName === 'order') {
                this.$refs.orderTableList.handleOpenCustomShow();
            } else if (this.tabActiveName === 'invoice') {
                this.$refs.orderPaymentList.handleOpenCustomShow();
            } else if (this.tabActiveName === 'payment') {
                this.$refs.orderInvoiceList.handleOpenCustomShow();
            }
        },

        // 列表选择事件
        selectionChange(ids) {
            this.selectedList = ids.map(item => item.order_id);
        },

        // 新建订单
        handleClickAddOrder() {
            this.addOrderDialogVisible = true
        },

        // 编辑订单
        handleClickEditOrder(order_id) {
            this.order_id = order_id
            this.editOrderDialogVisible = true
        },

        //撤销订单
        handleClickRevokeOrder(row) {
            this.$msgbox({
                title: '确认撤销吗？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '撤销',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                cancelApproval({
                    approval_id: row.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功')
                        this.getOrderTableList()
                    } else {

                    }
                })
            })
        },

        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id ? row.order_id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.order_id ? undefined : 'order_num'
                },
            });
        },

        //复制订单编号
        handleClickCopyOrderNum(num) {
            const textarea = document.createElement('textarea');
            textarea.value = num;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },

        //订单重新提交
        handleClickSubmitAgain(id) {
            this.order_id = id
            this.submitAgainOrderDialogVisible = true
        },

        //删除订单
        handleClickDelOrder(id) {
            this.$msgbox({
                title: '您确定要删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-yiwen',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger',
                confirmButtonClass: "el-button--danger",
            }).then(() => {
                orderDel({
                    order_id: id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功！')
                        this.getOrderTableList()
                    } else {

                    }
                })
            }).catch(() => {
                return false
            })
        },

        //关闭订单
        handleClickCloseOrder(id) {
            this.$msgbox({
                title: '您确定要关闭吗？',
                message: '关闭后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-yiwen',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger',
                confirmButtonClass: "el-button--danger",
            }).then(() => {
                orderClose({
                    order_id: id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('关闭成功！')
                        this.getOrderTableList()
                    } else {
                        //
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //复制订单
        handleClickCopyOrder(id) {
            this.order_id = id
            this.submitAgainOrderDialogVisible = true
        },

        //添加成员
        handleClickAddMember(order_id) {
            this.order_id = order_id
            this.teamMembersAddVisible = true
        },

        //新增代采
        handleClickAddPurchase(order_id) {
            this.order_id = order_id
            orderHasAfterSale({
                order_id: order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips)
                    } else {
                        this.orderPurchaseAddVisible = true
                    }
                } else {

                }
            })
        },

        //订单售后
        handleClickAfterSales(row) {
            this.order_id = row.order_id
            this.orderAfterSaleInfo = {
                customer_name: row.customer_name,
                order_num: row.order_num
            }
            orderHasAfterSale({
                order_id: row.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips)
                    } else {
                        this.orderAfterSaleDialog = true
                    }
                } else {

                }
            })
        },

        //点击查看关联客户详情
        handleClickRelateCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id.value,
                    name: row.customer_id.text,
                },
            });
        },

        //点击查看关联商机详情
        handleClickRelateProjectDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: row.project_id.value,
                    name: row.project_id.text,
                },
            });
        },

        handleSizeChange(val) {
            if (this.tabActiveName === 'order') {
                this.pagination.pageNum = 1
                this.pagination.pageSize = val.pageSize
                this.getOrderTableList()
            } else if (this.tabActiveName === 'invoice') {
                this.invoicePagination.pageNum = 1
                this.invoicePagination.pageSize = val.pageSize
                this.getOrderInvoiceList()
            } else if (this.tabActiveName === 'payment') {
                this.paymentPagination.pageNum = 1
                this.paymentPagination.pageSize = val.pageSize
                this.getOrderPaymentList()
            }
        },

        handleCurrentChange(val) {
            if (this.tabActiveName === 'order') {
                this.pagination.pageNum = val
                this.getOrderTableList()
            } else if (this.tabActiveName === 'invoice') {
                this.invoicePagination.pageNum = val
                this.getOrderInvoiceList()
            } else if (this.tabActiveName === 'payment') {
                this.paymentPagination.pageNum = val
                this.getOrderPaymentList()
            }
        },

        //订单列表
        handleColumnConfigChange(params) {
            const selectedFields = params.$table.getColumns().filter(column => column.visible).map(column => column.field)
            if (selectedFields.includes('is_expire_goods')) {
                if (!this.order_select_field.includes('is_expire_goods')) {
                    this.order_select_field.push('is_expire_goods')
                }
            } else {
                this.order_select_field = this.order_select_field.filter(item => item !== 'is_expire_goods')
            }
            if (selectedFields.includes('is_return_goods')) {
                if (!this.order_select_field.includes('is_return_goods')) {
                    this.order_select_field.push('is_return_goods')
                }
            } else {
                this.order_select_field = this.order_select_field.filter(item => item !== 'is_return_goods')
            }
            this.pagination.pageNum = 1
            this.getOrderTableList()
        },

        handleClickPaymentSearch() {
            this.paymentPagination.pageNum = 1
            this.getOrderPaymentList()
        },

        //获取回款汇总列表
        getOrderPaymentList() {
            this.loading = true
            this.receivable_no = ''
            orderRepaymentList({
                page: this.paymentPagination.pageNum,
                pageSize: this.paymentPagination.pageSize,
                keyword: this.paymentFilter.keyword,
                status: this.paymentFilter.status,
                payment_date: this.paymentFilter.payment_date ? this.paymentFilter.payment_date : [],
                payment_method: this.paymentFilter.payment_method,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.orderPaymentList = data
                    this.paymentPagination.total = total
                } else {

                }
                this.loading = false;
            })
        },

        //清空回款汇总筛选条件
        handleClickClearPaymentCondition() {
            this.paymentFilter = this.$options.data().paymentFilter
            this.paymentPagination.pageNum = 1
            this.getOrderPaymentList()
        },

        //点击新增回款
        handleClickAddRepayment() {
            this.repaymentDialogVisible = true
        },

        //点击查看回款记录详情
        handleClickPaymentDetail(row) {
            this.receivable_no = row.receivable_no
            this.repaymentDetailDialogVisible = true
        },

        //款项记录重新发起
        handleClickPaymentAgain(row) {
            this.receivable_no = row.receivable_no
            this.relate_order_id = row.order_no
            this.repaymentDialogVisible = true
        },

        //撤销款项记录
        handleClickPaymentRevoke(row) {
            this.$msgbox({
                title: '确定撤销当前回款记录？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_warning',
            }).then(() => {
                orderRepaymentRecordCancel({
                    receivable_no: row.receivable_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功！')
                        this.getOrderPaymentList()
                    } else {

                    }
                })
            }).catch(() => {
                return false
            })
        },

        handleClickInvoiceSearch() {
            this.invoicePagination.pageNum = 1
            this.getOrderInvoiceList()
        },

        //获取开票汇总列表
        getOrderInvoiceList() {
            this.loading = true
            orderInvoiceSummary({
                page: this.invoicePagination.pageNum,
                pageSize: this.invoicePagination.pageSize,
                keyword: this.invoiceFilter.keyword,
                status: this.invoiceFilter.status,
                apply_time: this.invoiceFilter.apply_time,
                invoice_type: this.invoiceFilter.invoice_type,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.orderInvoiceList = data
                    this.invoicePagination.total = total
                } else {

                }
                this.loading = false;
            })
        },

        //清空开票汇总筛选条件
        handleClickClearInvoiceCondition() {
            this.invoiceFilter = this.$options.data().invoiceFilter
            this.invoicePagination.pageNum = 1
            this.getOrderInvoiceList()
        },

        //点击查看开票详情
        handleClickInvoiceDetail(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDetailsDialogVisible = true
        },

        //点击新增开票申请
        handleClickAddInvoice() {
            this.invoiceDialogVisible = true
        },

        //点击撤销开票申请
        handleClickInvoiceRevoke(row) {
            this.$msgbox({
                title: '确定撤销当前开票记录？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_warning',
            }).then(() => {
                orderInvoiceRecordCancel({
                    invoice_no: row.invoice_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功！')
                        this.getOrderInvoiceList()
                    } else {

                    }
                })
            }).catch(() => {
                return false
            })
        },

        //点击重新发起开票申请
        handleClickInvoiceAgain(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDialogVisible = true
            this.relate_order_id = row.relate_id
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        //关联审批单详情
        handleClickRelatedApprovalDetail(item) {
            this.$showApprovalDetail({
                approval_id: item.id,
            }).then((res) => {

            });
        },
    },
    beforeDestroy() {
        EventBus.$off('orderUpdated', this.getOrderTableList);
    },
}
</script>
<style lang="scss" scoped>
.order_is_release {
    color: #666666;
}

.order_num_wrap {
    display: flex;
    gap: 4px;

    .icon-shenpi_weixuanzhong1 {
        color: #F0AA32;
    }

    .order_num {
        color: #2990FF;
        cursor: pointer;

        &.is_bad_debt {
            color: #E44144;
        }
    }
}

.status_name {
    color: #666666;
    vertical-align: middle;
    margin-right: 4px;

    &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
    }

    &.invoice_status_name_1::before {
        background: #F0AA32;
    }

    &.invoice_status_name_2::before {
        background: #5AB333;
    }

    &.invoice_status_name_3::before {
        background: #BFBFBF;
    }

    &.invoice_status_name_4::before {
        background: #E44144;
    }

    &.payment_status_name_1::before {
        background: #F0AA32;
    }

    &.payment_status_name_2::before {
        background: #5AB333;
    }

    &.payment_status_name_3::before {
        background: #E44144;
    }

    &.payment_status_name_4::before {
        background: #BFBFBF;
    }

    &.payment_status_name_5::before {
        background: #E44144;
    }
}
</style>
